import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { Translator } from '../translator.type';

export type ReceivedPartnershipRequest = {
  id: string;
  name: string;
  country: string;
  network: {
    name: string;
  };
};

export const RECEIVED_PARTNERSHIP_REQUESTS_COLUMNS = (
  t: Translator,
): ColumnDef<ReceivedPartnershipRequest>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: t('distributors.partnershipRequests.columns.name'),
  },
  {
    accessorKey: 'country',
    header: t('distributors.partnershipRequests.columns.country'),
  },
  {
    accessorKey: 'network.name',
    header: t('distributors.partnershipRequests.columns.network'),
  },
];
